import React from 'react';
import PageTabs from 'ui/PageTabs';

import { withAppContext } from './AppContext';

class PageTabsAccess extends React.Component {
    state = {
        tab: -1,
        tabs: [],
    };
    hasTab(num) {
        const { tabs } = this.state;
        return num < tabs.length;
    }
    findTab(num) {
        const { tabs } = this.state;
        return tabs[num] || tabs[0];
    }
    findTabUrl(num) {
        if (this.hasTab(num)) {
            return this.findTab(num).url;
        }
        return '';
    }
    findTabComponent(num) {
        return this.findTab(num).component;
    }
    findTabNumber(tabName) {
        const { tabs } = this.state;
        for (let i = 0; i < tabs.length; i += 1) {
            if (tabs[i].name === tabName) {
                return i;
            }
        }
        return 0;
    }
    componentDidMount() {
        this.updateTabs();
    }
    componentDidUpdate(oldProps) {
        const tabName = this.props.tab;
        const tabs = this.props.tabs;
        const tab = this.findTabNumber(tabName);
        if (oldProps.tab !== tabName || tab !== this.state.tab) {
            this.setState({ tab });
        }
        const changedTabs = tabs.some(item => {
            const oldTab = oldProps.tabs.find(
                subitem => subitem.name === item.name
            );
            if (!oldTab) {
                return false;
            }

            return item.hidden !== oldTab.hidden;
        });
        if (changedTabs) {
            this.updateTabs();
        }
    }
    updateTabs() {
        const { app } = this.props;
        const tabs = this.props.tabs.filter(tab =>
            tab.access ? app.canView(tab.access) : true
        );
        this.setState({ tabs });
    }
    onTabChange = tab => {
        if (tab !== this.state.tab) {
            this.setState({ tab });
            if (this.hasTab(tab)) {
                this.props.onChange(this.findTabUrl(tab));
            }
        }
    };
    render() {
        const { tab, tabs } = this.state;
        const { extra = {} } = this.props;
        if (tab === -1 || tabs.length === 0) {
            return null;
        }
        return (
            <PageTabs
                tabs={tabs.map(tab => tab.label)}
                hidden={tabs.filter(tab => tab.hidden).map(tab => tab.label)}
                current={tab}
                onChange={this.onTabChange}
            >
                {() => {
                    const Component = this.findTabComponent(tab);
                    if (Component) {
                        return <Component key={tab} extra={extra} />;
                    }
                }}
            </PageTabs>
        );
    }
}

export default withAppContext(PageTabsAccess);
